import { ProductModelType, type_code_bar } from '@teinor/erp/types/company/product'
import { connect, ConnectedProps } from 'react-redux'
import { ModalCreateEditStructure } from '../../../../../../../../../../baseComponents/ModalsLayouts/ModalCreateEdit'
import { ModalEditComponentProps } from '../../../../../../../../../../baseComponents/ModalsLayouts/types'
import { FormRender } from '../../../../../../../../../../forms/FormRenderer/types'
import { dictionaryComplexFromArr, dictionaryComplexFromJsonArr, TwinDictionary } from '../../../../../../../../../../utils/globals/dictionary'
import withLoading from '../../../../../../../../../../utils/hoc/withLoading'
import useTwinTranslation from '../../../../../../../../../../utils/hooks/useTwinTranslation'
import { AllReduxPayloads } from '../../../../../../../../../../utils/reducers'
import { VariantsPayload } from '../../../../../../../../../../utils/reducers/products/variants'
import useMeasureDictionary from '../../../../../../../../../../utils/hooks/useMeasureDictionary'
import useWasteWeightProduct from '../../../../../../../../../../utils/hooks/product/useWasteWeightProduct'
import { ProductExtendedTyShort } from '../../../../../../../../../Product/types'

type OtherInformationEditProductOrderTabProps = ModalEditComponentProps & OtherInformationEditProductOrderTabLogicProps & {
    basicData?: TwinDictionary
}

const OtherInformationEditProductOrderTab: React.FC<OtherInformationEditProductOrderTabProps> = ({basicData, ...logic}) => {
    const { t } = useTwinTranslation()
    const unitTypes = {
        0: { name: t('units', 'Unidades') },
        1: { name: t('measureU', 'U. Medida') }
    }
    const controlUnitTypes = {
        0: { name: t('units', 'Unidades') },
        1: { name: t('measureU', 'U. Medida') },
        2: { name: t('unitsAndMeasureU', 'Unidades y U. Medida') }
    }
    const { dictTypeCodeBar, variantsParsed } = useOtherInformationEditProductOrderTabLogic({ ...logic })
    const { measureItems } = useMeasureDictionary()
    const { dictWasteWeightType } = useWasteWeightProduct({ basicData: basicData as ProductExtendedTyShort })

    const fields: FormRender<ProductModelType> = [
        {
            cols: 2,
            title: t('references', 'Referencias'),
            elements: [
                {
                    label: t('typeCodeBar', 'Tipo de código de barras'),
                    name: 'type_code_bar',
                    component: 'CustomSelect',
                    items: dictTypeCodeBar,
                    readOnly: true,
                    value: basicData?.type_code_bar as any
                },
                {
                    label: t('codeBar', 'Código de barras'),
                    name: 'code_bar',
                    component: 'InputWithLabelMargin',
                    disabled: true,
                    value: basicData?.code_bar
                },
                {
                    label: t('customCodeBar', 'Código de barras personalizado'),
                    name: 'custom_code_bar',
                    disabled: true,
                    component: 'InputWithLabelMargin',
                    value: basicData?.custom_code_bar
                },
                {
                    label: t('secondaryReference', 'Referencia secundaria'),
                    name: 'secondaryReference',
                    disabled: true,
                    component: 'InputWithLabelMargin',
                    value: basicData?.secondaryReference
                },
                {
                    name: 'id',
                    component: 'InputHidden',
                },
            ]
        },
        {
            cols: 2,
            title: t('dimensionsAndWeight', 'Dimensión y peso'),
            elements: [
                {
                    label: t('dimensions', 'Dimensiones'),
                    name: 'dimensions',
                    component: 'InputWithLabelMargin',
                    disabled: true,
                    value: basicData?.dimensions
                },
                {
                    label: t('weight', 'Peso'),
                    name: 'weight',
                    component: 'InputWithLabelMargin',
                    disabled: true,
                    value: basicData?.weight
                },
                {
                    label: t('unitTypePurchase', 'Tipo de Unidades de Compra'),
                    name: 'unitTypePurchase',
                    component: 'CustomSelect',
                    items: unitTypes,
                    readOnly: true,
                    value: basicData?.unitTypePurchase
                },
                {
                    label: t('unitTypeSelling', 'Tipo de Unidades de Venta'),
                    name: 'unitTypeSelling',
                    component: 'CustomSelect',
                    items: unitTypes,
                    readOnly: true,
                    value: basicData?.unitTypeSelling
                },
                {
                    label: t('controlUnitType', 'Control de Unidades de Inventario'),
                    name: 'controlUnitType',
                    component: 'CustomSelect',
                    items: controlUnitTypes,
                    readOnly: true,
                    value: basicData?.controlUnitType
                },
                {
                    name: 'unitMeasure',
                    label: t('unitMeasure', 'Unidad de Medida'),
                    component: 'CustomSelectSectionsSearchbar',
                    items: measureItems,
                    readOnly: true,
                    value: basicData?.unitMeasure
                },
                {
                    label: t('wasteWeightType', 'Tipo de merma'),
                    name: 'wasteWeightType',
                    component: 'CustomSelectWithSearchBar',
                    items: dictWasteWeightType,
                    readOnly: true,
                    value: basicData?.wasteWeightType || '0',
                },
                {
                    label: t('wasteWeight', 'Merma'),
                    name: 'wasteWeight',
                    component: 'InputNumberWithLabelMargin',
                    value: basicData?.wasteWeight || '',
                    readOnly: true,
                },
                {
                    label: t('calculatedWeight', 'Peso calculado'),
                    name: 'calculatedWeight',
                    component: 'InputNumberWithLabelMargin',
                    readOnly: true,
                    value: basicData?.calculatedWeight || '',
                },
            ]
        },
        {
            cols: 2,
            title: t('others', 'Otros'),
            elements: [
                {
                    name: 'VariantGroupMainId',
                    label: t('variantGroupMain', 'Variante principal'),
                    component: 'CustomSelect',
                    items: variantsParsed,
                    readOnly: true,
                    value: basicData?.VariantGroupMainId
                },
            ]
        },
        {
            cols: 1,
            title: t('notes', 'Notas'),
            elements: [
                {
                    label: '',
                    name: 'notes',
                    component: 'TwinEditor',
                    readOnly: true,
                    defaultValue: basicData?.['notes'] ?? '',
                },
            ]
        }
    ]
    return(
        <div className='flex flex-col flex-auto' >
            <ModalCreateEditStructure
                translations={{ title: t('otherInformation', 'Otra información'), button: ''}}
                haveButtonPermissions={false}
                fields={fields}
                antiUnsaveTrigger={false} loading={false}
            />
        </div >
    ) 
}

interface OtherInformationEditProductOrderTabLogicProps extends ReduxVariants {}

const useOtherInformationEditProductOrderTabLogic = ({variants}: OtherInformationEditProductOrderTabLogicProps) => {
    const variantsParsed = dictionaryComplexFromJsonArr(variants?.variants || {})
    const dictTypeCodeBar = dictionaryComplexFromArr(type_code_bar as any)
    return {variantsParsed, dictTypeCodeBar}
}

const VariantsDispatch = {
    setVariants: (payload: VariantsPayload) => ({ type: 'CHANGE_VARIANTS', payload }),
}

export type ReduxVariants = ConnectedProps<typeof VariantsConnect>
const mapVariantsConnector = (state: AllReduxPayloads) => ({ variants: state.variants })
const VariantsConnect = connect(mapVariantsConnector, VariantsDispatch)

const VariantsConnectLoading = withLoading(OtherInformationEditProductOrderTab, [{ fetchUrl: '/api/app/product/productVariant/getAllVariantsComplete', propName: 'variants', setFunctionName: 'setVariants' }])

const OtherInformationEditProductOrderTabConnect = VariantsConnect(VariantsConnectLoading)

export default OtherInformationEditProductOrderTabConnect